// 🔧 auction_step.js
// ✅ Purpose: Pipeline step for the LGV Silent Auction Engine
// ✅ Features:
// - Executes the Auction Engine when Silent Auction is selected
// - Integrates with shared DemoContext
// - Returns standardized pipeline results
// - Fully block-commented for clarity and future devs

import { runAuctionEngine } from "../../engines/auction";

export const createAuctionStep = () => ({
  id: "auction_builder",

  name: "Auction Builder",

  label: "Auction Builder",

  run: async (demoContext) => {
    console.log("🔨 Auction Pipeline Step started.");

    const result = await runAuctionEngine({
      demoContext,
    });

    console.log("✅ Auction Pipeline Step completed.", {
      result,
    });

    return result;
  },
});